var map = {
	"./australia.png": "70ea",
	"./austria.png": "419f",
	"./belgium.png": "9edf",
	"./brazil.png": "c4d6",
	"./bulgaria.png": "8a56",
	"./canada.png": "34bb",
	"./chile.png": "a4a5",
	"./china.png": "85ac",
	"./cyprus.png": "687f",
	"./czechrepublic.png": "c4e0",
	"./denmark.png": "37fe",
	"./finland.png": "1b83",
	"./france.png": "829e",
	"./germany.png": "aed3",
	"./hongkong,china.png": "ff47",
	"./hungary.png": "3a28",
	"./iceland.png": "b893",
	"./ireland.png": "2446",
	"./italy.png": "8520",
	"./lithuania.png": "4429",
	"./newzealand.png": "09da",
	"./northmacedonia.png": "6908",
	"./norway.png": "7158",
	"./poland.png": "9c81",
	"./portugal.png": "33ae",
	"./russia.png": "a651",
	"./slovakia.png": "3af7",
	"./slovenia.png": "651a",
	"./spain.png": "a594",
	"./sweden.png": "00f2",
	"./switzerland.png": "827f",
	"./thailand.png": "f97f",
	"./thenetherlands.png": "664f",
	"./uk.png": "403c",
	"./usa.png": "130f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1c99";